<div #dropDownContainer class="ngx-dropdown-container" tabindex="0" (click)="clickedInside=true" (keydown)="onComponentFocused($event)" [ngClass]="{ 'ngx-disabled': disabled, 'is-invalid': invalid }">
    <button type="button" tabindex="-1" class="ngx-dropdown-button"
        [ngClass]="{ 'ngx-disabled': disabled, 'is-invalid': invalid }" [disabled]="disabled"
        (click)="toggleSelectDropdown()" appKeyupEnterEvent >
        <span *ngIf="showImage && selectedImageURL" class="flag" style="background-image: url({{selectedImageURL}});"></span>
        <span *ngIf="!isStatus" class="display-text" [title]="selectedItemsTitle()" #textwidth> {{ displayselectedDisplayText() }} </span>
        <span>
            <span *ngIf="isStatus">{{ displayselectedDisplayText() }}</span>
        </span>
        <span class="nsdicon-angle-down"></span>
    </button>
    <div #dropDownListContainer  class="ngx-dropdown-list-container" *ngIf="toggleDropdown" [style.maxHeight]="config.height" [ngClass]="{'hide-visible':hideVisible}">

        <div class="search-wrap" *ngIf="search">
            <input class="form-control" (change)="changeSearchText($event)" type="text" #searchBox
                [style.direction]="config.inputDirection" name="search-text" (input)="searchTextChanged()"
                [(ngModel)]="searchText" tabindex="-1" autocomplete="off" appAutofocus appPreventFirstSpace />

        </div>
        <span *ngIf="!singleSelect">
            <ul class="selected-items" *ngIf="selectedItems.length > 0">
                <li tabindex="-1" *ngFor="let selected of selectedItems; let i = index" (click)="deselectItem(selected, i)">
                    <span class="nsdicon-close" *ngIf="isClearable" appKeyupEnterEvent>&times;</span>
                    <span>
                        {{
                        config.displayFn
                        ? config.displayFn(selected)
                        : selected[displayKey] || selected
                        }}
                    </span>
                </li>
            </ul>
        </span>
        <hr *ngIf="!singleSelect && availableItems.length > 0" class="selectedItemsHR" />
        <ul class="available-items">
            <li #availableOption *ngFor="
            let item of availableItems
                | filterBy: searchText: combineDisplay||displayKey
                | limitTo: config.limitTo;
            let i = index
            " tabindex="-1" [ngClass]="{
            active: focusedItemIndex == i && !item.disabled,
            disabled: item.disabled
            }" (click)="selectItem(item, i)">
                <div *ngIf="isStatus"><span></span>{{
                    config.displayFn
                    ? config.displayFn(item)
                    : item[displayKey] || item
                    }}</div>
                <ng-container *ngIf="!isStatus">
                    <span *ngIf="showImage && item[imageURL]" class="flag " style="background-image: url({{item[imageURL]}});"></span>
                    {{
                    config.displayFn
                    ? config.displayFn(item)
                    : (combineDisplay 
                    ? item[combineDisplay] + ' (' + item[displayKey] + ')'
                    : item[displayKey]) || item
                    }}
                </ng-container>
            </li>
            <li *ngIf="showNotFound && !isLoading">{{ config.noResultsFound }}</li>
            <div class="scroll-loader-container" *ngIf="options.length == 0 && timeOutLoading() && isLoading">
                <div class="scroll-loader"></div>
            </div>
        </ul>
    </div>
</div>